// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  companyId: 'ASTRA199',
  defaultauth: 'fackbackend',
  //urlapi: 'http://localhost:8080/',
 // urlapi: 'https://clima-go.cloud/ClimaCloud', 
  urlapi: '/api',

  
  //urlapi: 'http://194.124.75.74:8080/',
  //urlapilogin: 'http://194.124.75.74:4200/dashboard',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
